export default __webpack_public_path__ + "static/media/pod-4.ddf35f2d.jpg";